import type { VueQueryPluginOptions } from "@tanstack/vue-query"
import {
  MutationCache,
  QueryCache,
  QueryClient,
  VueQueryPlugin,
  hydrate,
  dehydrate,
} from "@tanstack/vue-query"

export default defineNuxtPlugin(nuxt => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 5, // 5 seconds
      },
    },
    mutationCache: new MutationCache({
      onError(error, _variables, _ctx, mutation) {
        captureException(error, mutation.meta)
      },
    }),
    queryCache: new QueryCache({
      onError(error, query) {
        captureException(error, {
          extra: {
            queryKey: JSON.stringify(query.queryKey),
          },
        })
      },
    }),
  })

  const options: VueQueryPluginOptions = {
    queryClient,
  }

  nuxt.vueApp.use(VueQueryPlugin, options)

  if (import.meta.server) {
    nuxt.hooks.hook("app:rendered", () => {
      nuxt.payload.query = dehydrate(queryClient)
    })
  }

  if (import.meta.client) {
    hydrate(queryClient, nuxt.payload.query)
  }
})
